module.exports = __webpack_public_path__ + "f4cfba24e7317d51598da7e456ba2a8b.jpg";